import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8" {...props}><path className={styles["st0"] || "st0"} d="M4 8C1.8 8 0 6.2 0 4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-7C2.3 1 1 2.3 1 4s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z" fill="#fff" /><path className={styles["st0"] || "st0"} d="M4 5c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" fill="#fff" /></svg>);